import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Flex, Image, Step, StepDescription, StepIndicator, Stepper, StepSeparator, StepTitle, Td, Text, Th, Tr } from "@chakra-ui/react";
import PrimaryButton from "../primary-button";
import DropdownInput from "../../components/dropdown-input";
import DynamicModal from "../dynamic-modal";
import useLoader from "../../components/loader/loaderstates";
import Loader from "../../components/loader/loader";
import { FetchHistoryLogsOfReAssign, FetchUsersByClinic, updateAssignVisit } from "../../middleware/services/home";
import Toaster from "../toaster";
import { useNavigate } from "react-router-dom";
import SimpleTable from "../simple-table";
import { capitalizeFirstLetter, formatDate_Do_MMM_YYYY_Time } from "../../auth";

const AssignVisitLogs = ({ appointmentId }) => {
  const historyLogModal = useRef();
  const [historyData, setHistoryData] = useState([]);
  const [rolesData, setRolesData] = useState([]);
  const { isLoading, showLoader, dismissLoader } = useLoader();
  const { showSuccessToast, showErrorToast } = Toaster();
  const navigate = useNavigate()

  // Fetch the users and group them by role
  useEffect(() => {
    GetHistoryLog();
  }, []);

  const GetHistoryLog = async () => {
    const result = await FetchHistoryLogsOfReAssign({
      // doctorid: "",
      appointmentid: appointmentId,
    });

    if (result.output.result === "success") {
      const fetchedDoctors = result.output.data;
      setHistoryData(fetchedDoctors);
    } else {
      setHistoryData([]);
    }
    historyLogModal.current.openModal();
  };
  useEffect(() => {
    console.log(historyData, "historyData")
  }, [historyData])


  return (
    <>
      {isLoading && <Loader />}
      <DynamicModal
        ref={historyLogModal}
        modalWidth={historyData.length > 0 ? "40vw" : "40vw"}
        modalHeight="auto"
        modalMaxHeight="90vh"
        hasFooter={false}
        modalHeader="Assign Appointment History Log"
        modalBody={
          <>
            {historyData.length > 0 ? (
              <Stepper
                orientation="vertical"
                height="100%"
                size="xs"
                colorScheme="#CDCFD4"
                gap="0"
                pr="10px"
                // padding='1.5rem'
                w="100%"
                maxH='calc(100vh - 165px)'
                overflow='hidden auto'
              >

                {Array.isArray(historyData) && historyData.length > 0 ? (
                  historyData.map((item, index) => (
                    <Step w="100%">
                      <StepIndicator color="#E6E7E9" />
                      <Box flexShrink="0" w="95%">
                        <StepTitle
                          fontSize="0.75rem"
                          fontWeight="500"
                          color="#384052"
                          mb="0.5rem"
                          key={index}
                        >
                          {/* 10th Jan, 2024 */}
                        </StepTitle>
                        <StepDescription
                          bg="white"
                          w="100%"
                          border="1px solid #E6E7E9"
                          borderRadius="0.65rem"
                          p="1rem"
                          mb="1.5rem"
                          boxShadow="0px 8px 20px 0px #E6E7E966"
                        >
                          <Box>
                            <Box
                              display="flex"
                              justifyContent="space-between"
                              alignItems="center"
                              pb="0.5rem"
                            >
                              {/* <Text fontSize="0.875rem" color="#061027">
                          {item.reportname}
                        </Text> */}


                            </Box>

                            <Box cursor="pointer" display="flex" alignItems="center">

                            </Box>


                            <Flex w='100%' mb="0.75rem" justifyContent='space-between'>

                              <Box display='flex' flexDir='column'>

                                <Text fontSize="10px" color="gray.500" >
                                  Assign From
                                </Text>
                                <Box
                                  as="button"
                                >
                                  <Text fontSize="12px" fontWeight="600">
                                    {item.assignfrom ? item.assignfrom : "-"}
                                  </Text>
                                </Box>


                              </Box>

                              <Box display="flex" flexDirection="column" justifyContent="center" alignItems="flex-end">
                                <Text fontSize="10px" color="gray.500">
                                  Assigned To
                                </Text>
                                <Text fontSize="12px" fontWeight="600" >
                                  {item.assignto ? item.assignto : "-"}
                                </Text>
                              </Box>
                            </Flex>


                            <Flex w='100%' mb="0.75rem" justifyContent='space-between'>

                              <Box w='100%' display='flex' flexDir='column'>
                                <Text fontSize="10px" color="gray.500">
                                  Assigned Date
                                </Text>
                                <Text fontSize="12px" fontWeight="600">
                                  {item.assigndate ? formatDate_Do_MMM_YYYY_Time(item.assigndate) : "-"}
                                </Text>
                              </Box>

                              <Box w='100%' display='flex' flexDir='column' alignItems='flex-end'>

                                <Text fontSize="10px" color="gray.500">
                                  Status
                                </Text>
                                <Text fontSize="12px" fontWeight="600">
                                  {item.statusname ? capitalizeFirstLetter(item.statusname) : "-"}
                                </Text>

                              </Box>
                            </Flex>

                            <Flex w='100%' mb="0.75rem" justifyContent='space-between'>
                              <Box display='flex' flexDir='column' width="100%">

                                <Text fontSize="10px" color="gray.500">
                                  Completed Date
                                </Text>
                                <Text fontSize="12px" fontWeight="600">
                                  {item.completeddate ? formatDate_Do_MMM_YYYY_Time(item.completeddate) : "-"}
                                </Text>
                              </Box>

                              <Box w='100%' display='flex' flexDir='column' alignItems='flex-end'>

                                <Text fontSize="10px" color="gray.500">
                                  User Type
                                </Text>
                                <Text fontSize="12px" fontWeight="600">
                                  {item.assigntype ? item.assigntype : "-"}
                                </Text>
                              </Box>


                            </Flex>


                            <Flex w='100%' mb="0.75rem" justifyContent='space-between'>


                              <Box w='100%' display='flex' flexDir='column' >

                                <Text fontSize="10px" color="gray.500">
                                  Modified Date
                                </Text>
                                <Text fontSize="12px" fontWeight="600">
                                  {item.modifieddate ? formatDate_Do_MMM_YYYY_Time(item.modifieddate) : "-"}
                                </Text>

                              </Box>





                            </Flex>

                            {item.comment &&
                              <Box
                                bg="#F9FAFB"
                                borderLeft="2px solid #14C585"
                                p="0.5rem"
                              >
                                <Text
                                  fontSize="0.875rem"
                                  fontWeight="500"
                                  color="#384052"
                                >
                                  {item.comment}
                                </Text>
                              </Box>
                            }
                            {/* <Divider my="1rem" /> */}
                          </Box>

                        </StepDescription>
                      </Box>


                      <StepSeparator colorScheme="red" />
                    </Step>
                  ))

                ) : (
                  <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    gap="10px"
                    alignItems="center"
                    h="calc(100vh - 100px)"
                    w="100%"
                  >
                    <Box textAlign="left" fontSize="16px" fontWeight="600">
                      <Image
                        w="26px"
                        opacity="0.5"
                        src="/assets/imgs/biotech.png"
                      />
                    </Box>
                    <Text textAlign="left" fontSize="12px" fontWeight="500">
                      No Data avaiitemle
                    </Text>
                  </Box>
                )}
              </Stepper>

            ) : (
              <Text>No appointment assignment logs found!</Text>
            )
            }
          </>
        }
      />
    </>
  );
};

export default AssignVisitLogs;
